import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';

export default persistReducer({
    key: 'radario',
    storage,
  }, app);



// WEBPACK FOOTER //
// ./src/sub-projects/radario/reducers/index.ts